import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
  { src: "/imagesevent/event011.jpeg", alt: "Event" },
  { src: "/imagesevent/event012.jpeg", alt: "Event" },
  { src: "/imagesevent/event013.jpeg", alt: "Event" },
  { src: "/imagesevent/event014.jpeg", alt: "Event" },
  { src: "/imagesevent/event015.jpeg", alt: "Event" },
  { src: "/imagesevent/event016.jpeg", alt: "Event" },
  { src: "/imagesevent/event017.jpeg", alt: "Event" },
  { src: "/imagesevent/event018.jpeg", alt: "Event" },
  { src: "/imagesevent/event019.jpeg", alt: "Event" },
  { src: "/imagesevent/event020.jpeg", alt: "Event" },
 
  // Add more images gallery01
];

function Event02() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Event02;
